/** RecurrencePicker.tsx — 반복 패턴 선택 UI */
import { C, T, R } from './ui';

export type RecurType = 'none' | 'daily' | 'weekly';

interface Props {
  type: RecurType;
  days: string; // 'monday,wednesday,friday'
  onChange: (type: RecurType, days: string) => void;
}

const DAYS = [
  { id: 'monday', label: '월' },
  { id: 'tuesday', label: '화' },
  { id: 'wednesday', label: '수' },
  { id: 'thursday', label: '목' },
  { id: 'friday', label: '금' },
  { id: 'saturday', label: '토' },
  { id: 'sunday', label: '일' },
];

export default function RecurrencePicker({ type, days, onChange }: Props) {
  const dayList = days.split(',').filter(Boolean);

  function toggleDay(id: string) {
    const newDays = dayList.includes(id) ? dayList.filter(d => d !== id) : [...dayList, id];
    onChange('weekly', newDays.join(','));
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 5, marginBottom: 8 }}>
        <button onClick={() => onChange('none', '')}
          style={chipStyle(type === 'none')}>반복 없음</button>
        <button onClick={() => onChange('daily', '')}
          style={chipStyle(type === 'daily')}>매일</button>
        <button onClick={() => onChange('weekly', days || 'monday')}
          style={chipStyle(type === 'weekly')}>매주</button>
      </div>
      {type === 'weekly' && (
        <div style={{ display: 'flex', gap: 4, padding: '8px 10px',
          background: C.bgAlt, borderRadius: R.sm }}>
          {DAYS.map(d => {
            const act = dayList.includes(d.id);
            return (
              <button key={d.id} onClick={() => toggleDay(d.id)}
                style={{ width: 32, height: 32, borderRadius: '50%',
                  border: act ? `1.5px solid ${C.accent}` : `1px solid ${C.border}`,
                  background: act ? C.accent : C.white,
                  color: act ? C.white : C.sub,
                  fontSize: T.xs, fontWeight: 700, cursor: 'pointer' }}>
                {d.label}
              </button>
            );
          })}
        </div>
      )}
      {type === 'daily' && (
        <div style={{ fontSize: T.xs, color: C.muted, padding: '6px 10px', background: C.bgAlt, borderRadius: R.sm }}>
          매일 00시에 새 할 일이 자동으로 생성됩니다
        </div>
      )}
      {type === 'weekly' && dayList.length > 0 && (
        <div style={{ fontSize: T.xs, color: C.muted, marginTop: 5 }}>
          매주 {dayList.map(d => DAYS.find(x => x.id === d)?.label).join(', ')}요일 00시 자동 생성
        </div>
      )}
    </div>
  );
}

function chipStyle(act: boolean) {
  return {
    padding: '6px 14px', borderRadius: R.sm,
    border: act ? `1.5px solid ${C.accent}` : `1px solid ${C.border}`,
    background: act ? C.accentLt : C.white,
    color: act ? C.accent : C.sub,
    fontSize: T.sm, fontWeight: act ? 700 : 500, cursor: 'pointer',
  } as const;
}
